export const BASE_URL = process.env.BASE_URL;
export const MODE = process.env.MODE;
export const APP_APIKEY = process.env.APP_APIKEY;
export const PUSHER_APP_KEY = process.env.PUSHER_APP_KEY;


export const PARTNER360TOKEN = "6sgnqXPA";

// export const BASE_URL = "https://api.reviewbit.app/api";
// export const MODE = "PRODUCTION";
